import {Box} from 'platform/foundation';

import {ReactNode} from 'react';

const CELL_PADDING_VERTICAL = 3;
const CELL_PADDING_HORIZONTAL = 3;

interface SalesLeagueCellProps {
  children: ReactNode;
}

export function SalesLeagueCell(props: SalesLeagueCellProps) {
  return (
    <Box paddingVertical={CELL_PADDING_VERTICAL} paddingHorizontal={CELL_PADDING_HORIZONTAL}>
      {props.children}
    </Box>
  );
}
